import { render, staticRenderFns } from "./GoToStepButtonComponent.vue?vue&type=template&id=25e61a94"
import script from "./GoToStepButtonComponent.vue?vue&type=script&lang=ts"
export * from "./GoToStepButtonComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports